"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callFunction = callFunction;
exports.globalClickHandler = globalClickHandler;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function callFunction(_x, _x2) {
  return _callFunction.apply(this, arguments);
}

function _callFunction() {
  _callFunction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(toCall, eventName) {
    var params,
        flattenParams,
        _window,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            flattenParams = Object.keys(params).map(function (k) {
              return params[k];
            });
            document && document.dispatchEvent(new CustomEvent("mtn:".concat(eventName), {
              detail: params
            }));

            if (!(toCall && typeof toCall === 'function')) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return toCall.apply(void 0, _toConsumableArray(flattenParams));

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            if (!(toCall && typeof toCall === 'string' && window[toCall] && typeof window[toCall] === 'function')) {
              _context.next = 13;
              break;
            }

            _context.next = 12;
            return (_window = window)[toCall].apply(_window, _toConsumableArray(flattenParams));

          case 12:
            return _context.abrupt("return", _context.sent);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _callFunction.apply(this, arguments);
}

function globalClickHandler(e) {
  var node = e.target;

  if (node) {
    while (!node.getAttribute('id')) {
      node = node.parentElement;
    }

    node && node.getAttribute('id') && callFunction('mtnClickEventHandler', 'clickEvent', {
      id: node.getAttribute('id')
    });
  }
}